<template>
	<div>
		<v-card dense outlined class="d-flex flex-column overflow-hidden">
			<v-card-subtitle class="flex-shrink-0">
				<s-toolbar v-if="linesProduction.length == 0"
                    label="No existe proceso activo"
                    color="error"
					dark/> 
				<v-radio-group					
					row
					hide-details
					style="margin-top: -10px;"
					v-model="lineSelected">				
					<v-radio 
						v-for="line in linesProduction"
						:key="line.ClpID"
						:label="line.LncDescription"
						:value="line.ClpID"
					></v-radio>
				</v-radio-group>
			</v-card-subtitle>
			<v-container style="margin-bottom: 1.5rem; max-height: calc(85vh - 340px);" class="overflow-y-auto overflow-x-auto flex-grow-1">
				<v-row align="center">				
						
					
						<!-- <div class="containerLine">
							<div class="lineSide">
								<div v-for="table in itemsTablesOne" > 
									
									<div 
										class="stationWorkCpntFree" 
										:class="{ stationWorkCpntBusy: tableClickSelectedID == table.CttID, stationWorkCpntFree: tableClickSelectedID != table.CttID }"
										small
										@click="emitTable(table)"
									>
										{{ table.CttName }}
									</div>
									
								</div>
							</div>
							<div class="grafLine" v-if="showLine">
								
								
								
							</div>
							<div class="lineSide" >
								<div v-for="table in itemsTablesTwo"> 
									
									<div 
										class="stationWorkCpntFree" 
										:class="{ stationWorkCpntBusy: tableClickSelectedID == table.CttID, stationWorkCpntFree: tableClickSelectedID != table.CttID }"
										small
										@click="emitTable(table)"
									>
									
										{{ table.CttName }}
									</div>

								</div>
								
							</div>
						
				
							<div  style="position: absolute;top: 100%;left: 50%; transform: translate(-50%, -50%);" v-for="line in linesProduction">
								<v-chip
									small
									:color="line.CecColor">
									{{line.CecDescription}}
								</v-chip>
							</div>	
						</div>					 -->

						<div class="mesa-con-sillas" v-if="showLine">
							<div  class="textarea-container">
								<s-textarea 
									label="Comentario cambio de IQF"
									v-model="DescripcionIQF" 
									v-if="ShowDescripcionIQF">
									
								</s-textarea>
							</div>	
							<div style="display: flex; justify-content: center"><v-btn class="mt-4 mb-4" fab x-small color="info" @click="emitLine(lineProcess)"><v-icon>mdi-store mdi-18px</v-icon></v-btn></div>
							<div class="contenedor">
								<div class="lado lado-derecha">										
									<div v-for="(table, index) in itemsTablesOne" :key="'derecha-' + index" 
										:class="[
											'silla',
											{ 
												selectedsilla: tableClickSelectedID == table.CttID && table.CountDetail == 0,
												selectedConCount: tableClickSelectedID == table.CttID && table.CountDetail > 0,
												conCount: table.CountDetail > 0 && tableClickSelectedID != table.CttID
											}
										]"
										@click="emitTable(table)">
										<div v-if="table.CountDetail > 0" class="countDetailClass">{{ table.CountDetail }}</div>
										<span class="namesilla">{{ table.CttName }}</span>
									</div>
								</div>
								<div class="mesa">
									<!-- <div class="tablero"></div> -->
									<div class="bastidor">
										<span class="texto-bastidor">{{this.TipeExit}}</span>
									</div>
								</div>
								<div class="lado lado-izquierda">
									<div v-for="(table, index) in itemsTablesTwo" :key="'izquierda-' + index" 
										:class="[
											'silla',
											{ 
												selectedsilla: tableClickSelectedID == table.CttID && table.CountDetail == 0,
												selectedConCount: tableClickSelectedID == table.CttID && table.CountDetail > 0,
												conCount: table.CountDetail > 0 && tableClickSelectedID != table.CttID
											}
										]"
										@click="emitTable(table)">
										<div v-if="table.CountDetail > 0" class="countDetailClass">{{ table.CountDetail }}</div>
										<span class="namesilla">{{ table.CttName }}</span>
									</div>
								</div>	
														
							</div>
						</div>					
				</v-row>
			</v-container>
		</v-card>
		
	</div>
</template>
<script>
	import('../../../styles/linesPacking.css');

	import _sFrzCtnLinesProcessService from "@/services/FrozenProduction/FrzCtnLinesProcess.js"
	import SText from '../../Utils/SText.vue';
import { line } from "d3";


	export default {
  		components: { SText },
		props: {
			filter: {
				type: Object,
				default: null
			},		
			detailsArmed: {
				type: Object,
				default: null
			},	
		},

		data() {
			return {
				difProcess:0,
				itemsTablesOne:[],
        		itemsTablesTwo:[],
				linesProduction: [],
				lineSelected : 0,
				tables: [],
				tableClickSelectedID: 0,	
				showLine : false,	
				TipeExit: '',
				ShowDescripcionIQF: false,	
				DescripcionIQF: '',
				lineProcess: {},
			}
		},
		computed:{
			sillasDerecha() {
				// Divide las sillas en dos lados
				return Array.from({ length: Math.floor(this.itemsTablesOne.length) });
			},
			sillasIzquierda() {
				// Divide las sillas en dos lados
				return Array.from({ length: Math.ceil(this.itemsTablesTwo.length) });
			},
		},
		watch: {
			lineSelected() {
				
				this.GetTableByLine();
				this.showLine = true;
			}
		},

		methods: {
			emitTable( table ){
				
				table.DescripcionIQF = this.DescripcionIQF;
				table.difProcess=this.difProcess;	
				this.$emit("emitTable", table)
				this.tableClickSelectedID = table.CttID;
				
			},
			emitLine( lineProcess ){
				lineProcess.CttPosition = null;
				lineProcess.CttID = null;
				lineProcess.CttName = null;
				lineProcess.PdgNameGroup = null;
				lineProcess.PdgID = null;
				lineProcess.CttName = null;
				lineProcess.PchID = null;

				this.$emit("emitTable", lineProcess);
				this.tableClickSelectedID = 0;

				console.log("emitLine",lineProcess);
			},
			getLinesProduction() {
				
				console.log("this.filter",this.filter);
				_sFrzCtnLinesProcessService
				.linesactive(  this.filter , this.$fun.getUserID())
				.then(resp => {
					if(resp.status == 200)
					{						
						console.log("Lines active",resp.data);
						this.linesProduction = resp.data;
						if(this.linesProduction.length > 0){
							console.log("linesProduction",this.linesProduction);
	
							// let processInitial = JSON.parse(localStorage.getItem('processInitialData') || '{}');
							// processInitial.LncID = this.linesProduction[0].LncID;
							// localStorage.setItem('processInitialData', JSON.stringify(processInitial));
						}		
					}
				})
			},

			GetTableByLine()
			{
				this.tableClickSelectedID = 0;
				_sFrzCtnLinesProcessService
				.listTablesByLines({
					ClpID: this.lineSelected
				}, this.$fun.getUserID()).then(resp => {
					if(resp.status == 200){
						this.tables = resp.data;
						this.lineProcess = {...resp.data[0]};
							
						console.log('this.tables', this.tables);				
						this.itemsTablesOne = this.tables.filter(x => x.CttPosition == 1);					
                    	this.itemsTablesTwo = this.tables.filter(x => x.CttPosition == 2);
						this.TipeExit = this.itemsTablesOne[0].CecDescription;
						console.log('this.itemsTablesOne[0].CecID', this.itemsTablesOne[0]);
						console.log('this.detailsArmed.TypeProcess', this.detailsArmed);
						if(this.itemsTablesOne[0].CecDescription != this.detailsArmed.TypeDestination)
						{
							// this.ShowDescripcionIQF = true;
							// this.difProcess=1;
							this.ShowDescripcionIQF = false;
							this.difProcess=0;
							// this.$fun.alert("Debe registrar el motivo de cambio de Tunel de Congelamiento", "warning")
							
						}else{
							this.ShowDescripcionIQF = false;
							this.difProcess=0;
						}
					}
				})
			},

		},

		mounted () {
			console.log('detailsArmed', this.detailsArmed);
			this.getLinesProduction();		
		},
		created(){
			
		}
	}
</script>

<style>
.mesa-con-sillas {
	display: flex;
  	flex-direction: column;
	margin: 0 auto;
}
.contenedor {
	display: flex;
	justify-content: space-between;
}
.mesa {
	flex: 2;
	display: flex;
	position: relative;
	width: 100px; 
	align-items: center;
	justify-content: center;
	background-color: #f0f0f0; 
	border: 3px solid #d1d1d1; 
	border-radius: 10px;
} 

.tablero {
	width: 100%;
	height: 100%;
	background-color: #4b8a3d;
	border-radius: 10px;
	position: absolute;
	top: 0;
}

.bastidor {
	width: 70px;
	height: 40px;
	background-color: #4b8a3d;
	display: flex;
  	align-items: center;
  	justify-content: center;
	border-radius: 5px;
}

.texto-bastidor {
	color: #ffffff; 
	font-size: 12px; 
	font-weight: bold; 
	text-align: center;
	margin: 5px; 
}

/* .lado {
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	width: 150px;
} */

.sillas {
  	display: flex;
  	justify-content: space-between; 
  	width: 440px;
}

.lado-izquierda {
  align-items: flex-start; 
}

.lado-derecha {
  align-items: flex-end; 
}

.silla {
	display: flex;
	align-items: center; 
	justify-content: center; 
	padding: 10px;
	position: relative;
	background-color: #4eca8a; 
	border: 2px solid #2a8a66;
	border-radius: 5px;
	margin: 10px;
	min-width: 80px; 
	min-height: 40px; 
	cursor: pointer;
	transition: background-color 0.3s, border-color 0.3s;
} 

.selectedsilla{
	background-color: #0008ff !important; 
	border-color: #ffffff;
}

.conCount {
	background-color: yellow;
	border-color: #999;
}

.conCount .namesilla{
	color: #1A1A1A;
}

.selectedConCount {
	background-color: #0008ff;
}

.namesilla{
	text-align: center; 
	font-weight: bold;
  	font-size: 12px; 
  	color: #f0f0f0; 
} 

.textarea-container {
  
    margin-bottom: 20px; 
} 

.countDetailClass{
	position: absolute;
	top: -5px;
	left: -5px;
	background-color: #ff0000;
	color: #fff;
	border-radius: 50%;
	width: 20px;
	height: 20px;
	display: flex;
	align-items: center;
	justify-content: center;
}
</style>
